import { BatchJobApi, WebApiBatchJobDtoUpdateBatchJobDto } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class BatchJobService {

    public static GetBatchJob = async (batchJobId: number) => {
        return new BatchJobApi(GetApiConfiguration()).apiBatchJobGetStatusBatchJobIdGet({ batchJobId });
    };

    public static GetHistory = async () => {
        return new BatchJobApi(GetApiConfiguration()).apiBatchJobGetHistoryGet();
    };

    public static UpdateJob = async (updateJob: WebApiBatchJobDtoUpdateBatchJobDto) => {
        return new BatchJobApi(GetApiConfiguration()).apiBatchJobUpdatePut({ webApiBatchJobDtoUpdateBatchJobDto: updateJob });
    };


};
